import { inject, provide, ref, type InjectionKey, type Ref } from 'vue';
import type { FileSystemItem } from '../../types';

export type FileManagerDetailsState = {
  detailsItem: Ref<FileSystemItem | null>;
  openDetails: (item: FileSystemItem) => void;
  closeDetails: () => void;
};

export const fileManagerDetailsKey: InjectionKey<FileManagerDetailsState> =
  Symbol('fileManagerDetails');

export const provideFileManagerDetails = () => {
  const detailsItem = ref<FileSystemItem | null>(null);

  const openDetails = (item: FileSystemItem) => {
    detailsItem.value = item;
  };

  const closeDetails = () => {
    detailsItem.value = null;
  };

  const state: FileManagerDetailsState = {
    detailsItem,
    openDetails,
    closeDetails,
  };
  provide(fileManagerDetailsKey, state);
  return state;
};

export const useFileManagerDetails = () => {
  const state = inject(fileManagerDetailsKey);
  if (!state) {
    throw new Error(
      'useFileManagerDetails() must be called within a component tree provided by provideFileManagerDetails()',
    );
  }
  return state;
};
